/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import {
  useContext, useState, useEffect, useMemo,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import InstanceToolbar from '../../components/Toolbars/InstanceToolbar';
import { GroupsContext } from '../../context/GroupsProvider';
import UsersList from '../../components/UsersList';
import InstanceView from '../../components/InstanceView';
import VSManager from '../../components/VSManager';
import AddUser from '../../components/Modals/AddUser';
import MoreUsers from '../../components/Modals/MoreUsers';
import MoreMemory from '../../components/Modals/MoreMemory';
import DeactivateUser from '../../components/Modals/DeactivateUser';
import { AlertContext } from '../../context/AlertProvider';
import { ModalContext } from '../../context/ModalProvider';
import { TourContext } from '../../context/TourProvider';
import { AuthContext } from '../../context/AuthProvider';
import { UsersContext } from '../../context/UsersProvider';
import { FilesContext } from '../../context/FilesProvider';

import demoteDashPermission from '../../utils/demoteDashPermission';
import Loader from '../../juristec-ui/core/Loader';
import GroupsTable from '../../components/GroupsTable';
import GroupManager from '../../components/ProgressiveModals/GroupManager';
import Plans from '../../components/Modals/Plans';
import { PlanItem } from '../../components/ContractedPlan';

import { printSize } from '../../juristec-ui/utils/functions/lab';
import compare from '../../utils/functions/sorting';

const rolesLabel = {
  support: 'Suporte',
  super: 'Proprietário',
  scientist: 'Cientista',
  guest: 'Convidado',
};

const ROLEORDER = ['super', 'scientist', 'guest'];

const planInfo = [
  {
    planKey: 'label', label: 'Plano base', group: 0,
  },
  {
    planKey: 'volumeData', usedKey: 'size', label: 'Memória', group: 1, formatter: (val) => printSize(+(val) * 1024 ** 2),
  },
  {
    planKey: 'dashboards', label: 'Dashboards', group: 0, formatter: (val) => (val >= 100000 ? '\u221E' : val),
  },
  {
    planKey: 'supers', label: 'Usuários proprietários', group: 1,
  },
  {
    planKey: 'scientists', label: 'Usuários cientistas', group: 1,
  },
  {
    planKey: 'guests', label: 'Usuários convidados', group: 1,
  },
  {
    planKey: 'snapshots', label: 'Stories por dashboard', group: 0,
  },
  {
    planKey: 'scheduledSnapshotAllowed', label: 'Agendamento de stories', group: 0,
  },
  {
    planKey: 'maxHistory', label: 'Históricos de base', group: 1,
  },
  {
    planKey: 'scheduledHistoryAllowed', label: 'Agendamento de históricos', group: 1,
  },
  {
    planKey: 'publicLink', label: 'Link público', group: 0,
  },
  {
    planKey: 'publicLinkExpirationDays',
    label: 'Expiração link público',
    group: 0,
    formatter: (val) => (val >= 10000 ? '\u221E' : `${val} dia${val > 1 ? 's' : ''}`),
  },
  {
    planKey: 'publicLinkPwd', label: 'Senha para link público', group: 0,
  },
  {
    planKey: 'advancedCharts', label: 'Gráficos avançados', group: 1,
  },
  {
    planKey: 'externalKpis', label: 'KPI\'s externos', group: 1,
  },
  {
    planKey: 'subsetTableLimit', label: 'Subtabelas por dashboard', group: 1, formatter: (val) => (val >= 10000 ? '\u221E' : val),
  },
  {
    planKey: 'reportAmount', label: 'Relatórios', group: 0,
  },
  {
    planKey: 'attemptsPerHour', label: 'Tentativas de atualização de relatório por hora', group: 0,
  },
  {
    planKey: 'multifactor', label: 'Multifator obrigatório', group: 1,
  },
  {
    planKey: 'gptApi', label: 'Assistente virtual', group: 0,
  },
];

const UserManagement = () => {
  const history = useHistory();
  const [tab, setTab] = useState('users');
  const [inputFilter, setInputFilter] = useState('');

  const {
    user, userCompany, claimsUser, plans,
  } = useContext(AuthContext);
  const { state: filesState, filesAPI } = useContext(FilesContext);
  const { state: usersState, usersAPI } = useContext(UsersContext);
  const { tourOpen, nextStep, closeTour } = useContext(TourContext);
  const { setModalConfig, toggleModal, closeModal } = useContext(ModalContext);
  const { setAlertConfig } = useContext(AlertContext);
  const { state: groupsState, groupsAPI } = useContext(GroupsContext);
  const theme = useTheme();

  useEffect(() => {
    usersAPI.getUsers();
    groupsAPI.getGroups();
  }, []);

  useEffect(() => {
    if (!filesState.started) {
      (async () => {
        await filesAPI.init();
      })();
    }
  }, [filesState.started, filesAPI]);

  const [usersList, setUsersList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [filteredGroupsList, setFilteredGroupsList] = useState([]);
  const [usersRolesQty, setUsersRolesQty] = useState({
    supers: 0, scientists: 0, guests: 0,
  });

  const [userAgentsChanges, setUserAgentsChanges] = useState(null);

  const contractedPlanInfo = useMemo(() => {
    const selectedPlan = plans?.[userCompany?.plan];
    const fixedCompany = {
      ...userCompany,
      supers: userCompany?.superS || undefined,
    };
    return planInfo.map((infoData) => {
      const item = new PlanItem(infoData);
      item.setContracted(fixedCompany, selectedPlan);
      item.setUsed(usersRolesQty, filesState);
      return item;
    });
    // return planInfo;
  }, [
    usersRolesQty.supers,
    usersRolesQty.scientists,
    usersRolesQty.guests,
    userCompany,
    plans,
    filesState,
  ]);

  // Recebe a lista de usuarios e faz as alteracoes necessarias para a visualizacao
  useEffect(() => {
    setUsersList([]);
    const rolesQty = { supers: 0, scientists: 0, guests: 0 };
    setUsersList(
      usersState.users?.reduce((list, userData) => {
        rolesQty[`${userData.role}s`] += 1;
        if (user.role === 'scientist' && user.uid !== userData.uid && userData.scientist !== user.uid) {
          return list;
        }
        list.push({
          ...userData,
          roleLabel: rolesLabel[userData.role],
          scientistName: usersState.users.find((u) => u.id === userData.scientist)?.name || '-',
        });
        return list;
      }, []) || [],
    );
    setUsersRolesQty(rolesQty);
  }, [usersState?.users]);

  useEffect(() => {
    setFilteredGroupsList(groupsState.groups);
  }, [groupsState.groups]);

  // Filtra a lista de usuarios
  useEffect(() => {
    const filterTxt = inputFilter.trim();
    const hasText = (txt) => txt.toLowerCase().includes(filterTxt.toLowerCase());
    if (filterTxt.length > 0) {
      if (tab === 'users') {
        setFilteredUsersList(usersList.filter((userData) => (
          hasText(userData.name) || hasText(userData.email) || hasText(userData.roleLabel)
        )));
      } else {
        setFilteredGroupsList(groupsState.groups.filter((group) => (
          hasText(group.name)
        )));
      }
    } else {
      setFilteredUsersList(usersList);
      setFilteredGroupsList(groupsState.groups);
    }
  }, [usersList, inputFilter, groupsState.groups]);

  // Grupos dos usuários cadastrados na instância
  const groupsList = groupsState.groups.map((group) => ({
    label: group.name,
    value: group.id,
    id: group.id,
    ...group,
  }));

  const checkLimits = (instance, count, role, oldRole) => {
    const auxCount = { ...count };
    auxCount[`${role}s`] += 1;
    if (oldRole) auxCount[`${oldRole}s`] -= 1;
    if ((auxCount.supers ?? 0) === 0) {
      setAlertConfig({
        type: 'error',
        text: 'Instância deve ter no mínimo 1 proprietário',
      });
      return false;
    }
    let used = 0;
    let capacity = 0;
    let errorMsg = '';
    ROLEORDER.forEach((r) => {
      used += auxCount[`${r}s`];
      capacity += (instance[`${r}s`] ?? instance[`${r}S`] ?? 0);
      if (used > capacity) {
        errorMsg = `Limite máximo de usuários ${rolesLabel[r].toLowerCase()}s atingido nesta instância`;
      }
    });
    if (errorMsg.length > 0) setAlertConfig({ type: 'error', text: errorMsg });
    return errorMsg.length === 0;
  };

  // Adicao de novo usuario
  const handleAddUser = () => {
    const actionLabel = !userCompany.loginProvider?.length > 0 ? 'Adiciona' : 'Provisiona';
    if (tourOpen) nextStep();

    const submitAddUser = async (userInfo) => {
      if (!checkLimits(userCompany, usersRolesQty, userInfo.role)) return;
      const { error, msg, raw } = await usersAPI.addUser({
        ...userInfo,
        send_email: userInfo.sendEmail,
        volumedata: 500,
      });

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        usersAPI.getUsers();
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Usuário ${actionLabel.toLowerCase()}do com sucesso!`,
        okFunction: () => {
          usersAPI.getUsers();
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: `${actionLabel}r Novo Usuário`,
      className: 'newUser_modal',
      children: (
        <AddUser
          user={user}
          userIsAdmin={claimsUser?.is_admin}
          usersEmails={[...usersList.map((u) => u.email)]}
          scientistEmails={[...usersList.filter((u) => u.role !== 'guest')].map((e) => ({
            value: e.id,
            label: e.name,
            id: e.id,
          }))}
          hide={() => {
            toggleModal();
            if (tourOpen) closeTour();
          }}
          submitData={submitAddUser}
          fromAdmin={false}
          groupsList={groupsList}
          tourContext={{ tourOpen, nextStep }}
        />
      ),
    });
  };

  const handleEditUser = (editedUser) => {
    const submit = async (newObject) => {
      if (!checkLimits(userCompany, usersRolesQty, newObject.role, editedUser.role)) return;
      const { error, msg, raw } = await usersAPI.newEditUser(
        editedUser.uid,
        newObject,
      );

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        usersAPI.getUsers();
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Usuário editado com sucesso!',
        okFunction: () => {
          usersAPI.getUsers();
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: 'Editar Usuário',
      className: 'editUser_modal',
      children: (
        <AddUser
          user={user}
          userIsAdmin={claimsUser?.is_admin}
          usersEmails={[...usersList.map((u) => u.email)]}
          scientistEmails={[...usersList.filter((u) => u.role !== 'guest')].map((e) => ({
            value: e.id,
            label: e.name,
            id: e.id,
          }))}
          hide={() => {
            toggleModal();
            if (tourOpen) closeTour();
          }}
          submitData={submit}
          fromAdmin={false}
          groupsList={groupsList}
          isEdit
          editAttributes={editedUser}
          edittingSelf={user.uid === editedUser.uid}
          tourContext={{ tourOpen, nextStep }}
        />
      ),
    });
  };

  // Retorna o novo cargo de acordo com a booleana passada e o cargo atual
  const getNewUserRole = (promote, selectedUser) => {
    switch (selectedUser?.role) {
      case 'guest':
        if (promote) return 'scientist';
        return 'guest';
      case 'scientist':
        if (promote) return 'super';
        return 'guest';
      case 'super':
        if (promote) return 'super';
        return 'scientist';
      default:
        return '';
    }
  };

  // Promocao ou rebaixamento de cargo
  const handleRoleChange = async (p, selectedUser) => {
    const newRole = getNewUserRole(p, selectedUser);
    const { error, raw } = await usersAPI.newEditUser(
      selectedUser.uid, { role: newRole, scientist: newRole === 'guest' ? user.uid : '' },
    );
    // const { error, raw } = await usersAPI.editUser(email, newRole);
    if (error) {
      if (raw.match(/CODE 403/)) {
        setAlertConfig({
          type: 'error',
          text: 'Permissão insuficiente',
          child: 'Seu usuário não possui a permissão necessária para essa ação!',
          okFunction: () => {
            usersAPI.getUsers();
          },
        });
      } else {
        setAlertConfig({
          type: 'error',
          text: 'Algo deu errado',
          child: raw,
          okFunction: () => {
            usersAPI.getUsers();
          },
        });
      }
      return;
    }

    if (newRole === 'guest') {
      await demoteDashPermission(selectedUser.uid);
    }

    setAlertConfig({
      type: 'success',
      text: 'Usuário atualizado com sucesso!',
      okFunction: () => {
        usersAPI.getUsers();
      },
    });
  };

  // Bloqueia ou desbloqueia o usuario
  const handleUserState = async (selectedUser) => {
    const { error, raw } = await usersAPI.newEditUser(
      selectedUser.uid, { disabled: !selectedUser.disabled },
    );
    // const {
    //   error, raw,
    // } = await usersAPI.toggleUserBlock(email, disabled ? 'False' : 'True');
    if (error) {
      if (raw.match(/CODE 403/)) {
        setAlertConfig({
          type: 'error',
          text: 'Permissão insuficiente',
          child: 'Seu usuário não possui a permissão necessária para essa ação!',
          okFunction: () => {
            usersAPI.getUsers();
          },
        });
      } else {
        setAlertConfig({
          type: 'error',
          text: 'Algo deu errado',
          child: raw,
          okFunction: () => {
            usersAPI.getUsers();
          },
        });
      }
      return;
    }
    setAlertConfig({
      type: 'success',
      text: `Usuário ${!selectedUser.disabled ? 'desativado' : 'ativado'} com sucesso!`,
      okFunction: () => {
        usersAPI.getUsers();
      },
    });
  };

  // Lida com a remocao do usuario selecionado
  const handleDeleteUser = (selectedUser) => {
    const submitDelete = async (transferToEmail) => {
      const { raw, error } = await usersAPI.deleteUser(selectedUser.email, transferToEmail);
      if (error) {
        if (raw.match(/CODE 409/)) {
          setAlertConfig({
            type: 'error',
            text: 'Permissão insuficiente',
            child: 'Seu usuário não possui a permissão necessária para essa ação!',
            okFunction: () => {
              usersAPI.getUsers();
            },
          });
        } else if (raw.includes('HELPDESK delete_user: ')) {
          // Temporario, a mensagem deve vir correta do backend
          // Atualmente ela vem em um JSON com erro de sintaxe
          const msg = (raw.split('[')[1]).split(']')[0];
          const humanMsg = JSON.parse(msg.replace(/\\"/g, '"').replace(/\\\\/g, '\\'));
          setAlertConfig({
            type: 'error',
            text: 'Algo deu errado',
            child: decodeURIComponent(`${humanMsg.description} Por favor, abra um ticket no suporte para que possamos ajudá-lo!`),
            okFunction: () => {
              usersAPI.getUsers();
            },
          });
        } else {
          setAlertConfig({
            type: 'error',
            text: 'Algo deu errado',
            child: raw,
            okFunction: () => {
              usersAPI.getUsers();
            },
          });
        }
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Usuário removido com sucesso!',
        okFunction: () => {
          usersAPI.getUsers();
        },
      });
    };

    setModalConfig({
      title: 'Remover usuário',
      children: (
        <DeactivateUser
          user={selectedUser}
          instanceUsers={usersList}
          theme={theme}
          submit={submitDelete}
          hide={closeModal}
        />
      ),
    });
  };

  // Lida com a modal de solicitações, e envia o email com o que foi solicitado
  const handleSolicitationModal = (solicitation) => {
    const sendSolicitationEmail = (data) => {
      // TODO metodo para enviar os dados solicitados por email
      // eslint-disable-next-line no-console
      console.log(data);
    };

    if (solicitation === 'users') {
      setModalConfig({
        title: 'Solicitar Novos Usuários',
        children: (
          <MoreUsers
            hide={() => {
              toggleModal();
              if (tourOpen) closeTour();
            }}
            submitData={sendSolicitationEmail}
          />
        ),
      });
    } else {
      setModalConfig({
        title: 'Solicitar Memória',
        children: (
          <MoreMemory
            hide={() => {
              toggleModal();
              if (tourOpen) closeTour();
            }}
            submitData={sendSolicitationEmail}
          />
        ),
      });
    }
  };

  const openPlans = () => {
    let preparedPlans = Object.values(plans).sort((a, b) => a.volumeData - b.volumeData);
    preparedPlans = preparedPlans.reduce((aux, plan) => {
      let key = '';
      const it = planInfo.reduce((list, infoData) => {
        if (infoData.planKey === 'label') {
          key = plan.label;
          return list;
        }
        const item = new PlanItem(infoData);
        item.setContracted({}, plan);
        if (item.contracted !== undefined) list.push(item);
        return list;
      }, []);
      aux[key] = it;
      return aux;
    }, {});
    setModalConfig({
      title: 'Planos Disponíveis',
      yesFunc: closeModal,
      yesLabel: 'Ok',
      children: (
        <Plans
          plans={preparedPlans}
        />
      ),
    });
  };

  const handleCreateGroup = () => {
    const usersOptions = usersList.map((u) => ({
      ...u,
      label: u.name,
      value: u.id,
      id: u.id,
    }));
    const submitCreateGroup = async (groupData, users) => {
      const { error, msg, raw } = await groupsAPI.createGroup({
        name: groupData.name,
        description: groupData.description,
      }, users);

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Grupo criado com sucesso!',
        okFunction: () => {
          groupsAPI.getGroups();
          usersAPI.getUsers();
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: 'Criar Novo Grupo',
      children: (
        <GroupManager
          key="createGroup"
          users={usersOptions}
          submit={submitCreateGroup}
          hide={toggleModal}
        />
      ),
    });
  };

  // Add this handler for editing groups
  const handleEditGroup = (group, usersOnly = false) => {
    const sharedWith = [];
    const usersOptions = usersList.map((u) => {
      const userOpt = {
        ...u,
        label: u.name,
        value: u.id,
        id: u.id,
      };
      if (u.groups?.includes(group.id)) sharedWith.push(userOpt);
      return userOpt;
    });
    const submitEditGroup = async (groupData, users) => {
      const { error, msg, raw } = await groupsAPI.updateGroup(group.id, {
        name: groupData.name,
        description: groupData.description,
      }, users);

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Grupo atualizado com sucesso!',
        okFunction: () => {
          groupsAPI.getGroups();
          usersAPI.getUsers();
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: usersOnly ? `Usuários do Grupo ${group.name}` : 'Editar Grupo',
      children: (
        <GroupManager
          key={group.id}
          users={usersOptions}
          groupData={group}
          shared={sharedWith}
          submit={submitEditGroup}
          hide={toggleModal}
          usersOnly={usersOnly}
        />
      ),
    });
  };

  const handleDeleteGroup = (group) => {
    const submitDeleteGroup = async () => {
      const { error, msg, raw } = await groupsAPI.deleteGroup(group.id);
      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Grupo removido com sucesso!',
        okFunction: () => {
          groupsAPI.getGroups();
          usersAPI.getUsers();
        },
      });
    };
    setModalConfig({
      type: 'warning',
      children: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <span>
            Tem certeza que deseja apagar o grupo
            {' '}
            <strong>{group.name}</strong>
            ?
          </span>
          <span>Essa ação não pode ser desfeita.</span>
        </div>
      ),
      yesFunc: () => {
        submitDeleteGroup();
        closeModal();
      },
      notFunc: closeModal,
      yesLabel: 'Sim',
      notLabel: 'Não',
      title: 'Apagar Grupo',
    });
  };

  const openUsersModal = (group) => {
    handleEditGroup(group, true);
  };

  const getAgentsUsers = async () => {
    const resUsers = await usersAPI.getAgentsUsersUsedTokens(userCompany.id);
    const agentsByUsers = {};
    const agentsUsed = {
      chat: 0, insight: 0, quickDash: 0, dashSummary: 0,
    };
    if (resUsers.error) {
      setAlertConfig({
        type: 'error',
        text: resUsers.msg,
        child: resUsers.raw,
      });
      return { agentsByUsers, agentsUsed, validUsers: [] };
    }
    const validUsers = usersList.reduce((aux, u) => {
      if (u.role !== 'guest') {
        agentsByUsers[u.id] = {
          chat: {
            allowed: u.agents?.chat ?? true,
            used: resUsers.tokens?.chat?.[u.id] ?? 0,
          },
          insight: {
            allowed: u.agents?.insight ?? true,
            used: resUsers.tokens?.insight?.[u.id] ?? 0,
          },
          quickDash: {
            allowed: u.agents?.quickDash ?? true,
            used: resUsers.tokens?.quickDash?.[u.id] ?? 0,
          },
          dashSummary: {
            allowed: u.agents?.dashSummary ?? true,
            used: resUsers.tokens?.dashSummary?.[u.id] ?? 0,
          },
        };
        agentsUsed.chat += agentsByUsers[u.id].chat.used;
        agentsUsed.insight += agentsByUsers[u.id].insight.used;
        agentsUsed.quickDash += agentsByUsers[u.id].quickDash.used;
        agentsUsed.dashSummary += agentsByUsers[u.id].dashSummary.used;
        aux.push(u);
      }
      return aux;
    }, []).sort((a, b) => (compare(a.name, b.name)));
    return { agentsByUsers, agentsUsed, validUsers };
  };

  const handleSubmitAgents = async () => {
    if (userAgentsChanges === null) return;
    const toSubmit = Object.entries(userAgentsChanges).reduce((aux, [k, v]) => {
      // eslint-disable-next-line no-param-reassign
      aux[k] = {
        agents: {
          chat: v.chat.allowed,
          insight: v.insight.allowed,
          quickDash: v.quickDash.allowed,
          dashSummary: v.dashSummary.allowed,
        },
      };
      return aux;
    }, {});
    const res = await usersAPI.changeUsersAgentsPerms(toSubmit);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }
    setAlertConfig({
      type: 'success',
      text: 'Permissões editadas com sucesso!',
      okFunction: () => {
        usersAPI.getUsers();
        toggleModal();
      },
    });
  };

  return (
    <>
      {(filesState.isLoading || usersState.isLoading || groupsState.isLoading) && <Loader />}
      <InstanceToolbar
        goBack={history.goBack}
        tab={tab}
        setTab={setTab}
        addFunc={tab === 'groups' ? handleCreateGroup : handleAddUser}
        currentUser={user}
        inputFilter={inputFilter}
        setInputFilter={setInputFilter}
        saveVSManager={handleSubmitAgents}
        hasAccessToVirtualAssistant={
          userCompany?.gptApi && (userCompany?.gptAgents ?? []).length > 0
        }
        hasLoginProvider={userCompany.loginProvider?.length > 0}
      />
      {tab === 'users' && (
        <UsersList
          users={filteredUsersList}
          currentUser={user}
          promoteUser={(selectedUser) => handleRoleChange(true, selectedUser)}
          demoteUser={(selectedUser) => handleRoleChange(false, selectedUser)}
          toggleUserState={handleUserState}
          deleteUser={handleDeleteUser}
          editUser={handleEditUser}
          openUserHistory={() => {}}
          groups={groupsState.groups.map((group) => ({
            label: group.name,
            value: group.id,
            id: group.id,
            ...group,
          }))}
        />
      )}
      {tab === 'instance' && (
        <InstanceView
          users={usersList}
          planInfo={contractedPlanInfo}
          usersRolesQty={usersRolesQty}
          memoryInfo={{ used: filesState.size, max: parseFloat(userCompany?.volumeData || 0) }}
          dashboardsQty={filesState.dashboards}
          openPlans={openPlans}
          solicitationModal={handleSolicitationModal}
        />
      )}
      {tab === 'groups' && (
        <GroupsTable
          groups={filteredGroupsList}
          onDelete={handleDeleteGroup}
          onEdit={handleEditGroup}
          users={usersList}
          openUsersModal={openUsersModal}
        />
      )}
      {tab === 'virtualAssistant' && userCompany?.gptApi && (userCompany?.gptAgents ?? []).length > 0 && (
        <VSManager
          allowedAgents={userCompany?.gptAgents ?? []}
          userAgentsChangesState={[userAgentsChanges, setUserAgentsChanges]}
          getAgentsUsers={getAgentsUsers}
        />
      )}
    </>
  );
};

export default UserManagement;
